import { UsePointToProjectionResult } from '@/utils/map/usePointToProjection';
import { Feature } from 'ol';
import type { MarkerPin } from 'minerva-plugin-api';
import { getMarkerSingleFeature } from './getMarkerSingleFeature';

export const getMarkersFeatures = (
  markers: MarkerPin[],
  {
    pointToProjection,
  }: {
    pointToProjection: UsePointToProjectionResult;
  },
): Feature[] => {
  return markers.map(marker =>
    getMarkerSingleFeature(marker, {
      pointToProjection,
    }),
  );
};
